module.exports = __webpack_public_path__ + "static/media/send.0885f5d1.svg";